import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { StepViewModel } from '@app/shared/model/stepViewModel';
import { StepWrapperComponent } from './components/step-wrapper/step-wrapper.component';
import { ModalComponent as ModalComponent_1 } from '../modal/modal.component';

@Component({
  selector: 'app-step-flow',
  templateUrl: './step-flow.component.html',
  styleUrls: ['./step-flow.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [StepWrapperComponent, ModalComponent_1],
})
export class StepFlowComponent {
  @Input() public model: StepViewModel<string, object>;
  @ViewChild('exitModal', { static: false }) public exitModal: ModalComponent;

  public openExitModal(): void {
    if (this.exitModal) {
      this.exitModal.open();
    }
  }

  public navigateToHome(): void {
    this.exitModal.close();
    window.location.href = window.location.origin + '/home';
  }
}
